import { render, staticRenderFns } from "./GenericCreateRole.vue?vue&type=template&id=922cbfde&scoped=true"
import script from "./GenericCreateRole.vue?vue&type=script&lang=js"
export * from "./GenericCreateRole.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/CU_artist.css?vue&type=style&index=0&id=922cbfde&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922cbfde",
  null
  
)

export default component.exports